import {EMPTY_STRING} from './config.js'

export const getPlaceholder = ({basePlaceholder, formatter, value}) =>
  value ? `${basePlaceholder} ${formatter({value})}` : EMPTY_STRING
